<template>
  <div class="onboarding-final">
    <section class="finish-hero">
      <h1 class="finish-hero__title">You're all set!</h1>
    </section>

    <section class="upsell">
      <div class="upsell__head">
        <span class="upsell__pill">
          <i class="fas fa-crown"></i> Premium
        </span>
        <h2 class="upsell__title">Go further with Premium</h2>
        <p class="upsell__lede">
          Here's a taste of what you'd unlock by upgrading.
        </p>
      </div>

      <div class="upsell__grid">
        <div
          v-for="f in upsellFeatures"
          :key="f.title"
          class="upsell__tile"
        >
          <div
            class="upsell__tile-icon"
            :style="{ background: f.color || 'rgba(158, 128, 255, 0.15)' }"
          >
            <i :class="f.icon"></i>
          </div>
          <div class="upsell__tile-title">{{ f.title }}</div>
          <div class="upsell__tile-desc">{{ f.description }}</div>
        </div>
      </div>

      <div class="upsell__cta-row">
        <a href="/get-premium" class="finish-btn finish-btn--premium">
          <i class="fas fa-crown"></i> See Premium plans
        </a>
        <button class="finish-btn finish-btn--ghost" @click="skipOnboarding">
          Skip and go to dashboard <i class="fas fa-arrow-right"></i>
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import premiumFeatures from "./premium-features.json";

export default {
  name: "OnboardingFinal",
  methods: {
    skipOnboarding() {
      const guild_id = this.$route.params.guild_id;
      this.$router.push(`/dashboard/${guild_id}`);
    },
  },
  computed: {
    upsellFeatures() {
      return premiumFeatures.filter((f) => f.headline);
    },
    current_user() {
      return this.$store.state.discord_user || {};
    },
  },
};
</script>

<style scoped>
.onboarding-final {
  min-height: 90vh;
  background: #22222a;
  color: #fefefe;
  font-family: "Poppins", "Roboto", sans-serif;
  padding: 48px 24px 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 36px;
}

/* ---------- Finish hero ---------- */
.finish-hero {
  width: 100%;
  max-width: 720px;
  text-align: center;
}
.finish-hero__title {
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-size: 32px;
  color: #fff;
  margin: 0 0 10px;
  letter-spacing: -0.5px;
}

/* ---------- Upsell section ---------- */
.upsell {
  width: 100%;
  max-width: 820px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 32px 32px 28px;
}
.upsell__head {
  text-align: center;
  margin-bottom: 24px;
}
.upsell__pill {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 5px 13px;
  background: rgba(248, 203, 0, 0.12);
  border: 1px solid rgba(248, 203, 0, 0.4);
  color: #f8cb00;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-radius: 999px;
  margin-bottom: 14px;
}
.upsell__title {
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-size: 26px;
  color: #fff;
  margin: 0 0 8px;
  letter-spacing: -0.3px;
}
.upsell__lede {
  font-size: 14px;
  color: #b8b6c8;
  margin: 0;
}

.upsell__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 14px;
  margin-bottom: 26px;
  text-align: left;
}
.upsell__tile {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 16px;
  transition: transform 0.2s ease, border-color 0.2s ease;
}
.upsell__tile:hover {
  transform: translateY(-2px);
  border-color: rgba(158, 128, 255, 0.35);
}
.upsell__tile-icon {
  width: 36px;
  height: 36px;
  border-radius: 9px;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  margin-bottom: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}
.upsell__tile-title {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 14.5px;
  color: #fff;
  margin-bottom: 4px;
}
.upsell__tile-desc {
  font-size: 12.5px;
  line-height: 1.5;
  color: #b8b6c8;
}

.upsell__cta-row {
  display: flex;
  gap: 12px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

/* ---------- Buttons ---------- */
.finish-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 11px 22px;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 14px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.15s ease, color 0.15s ease, transform 0.15s ease;
}
.finish-btn--primary {
  background: #9e80ff;
  color: #fff;
}
.finish-btn--primary:hover {
  background: #b29bff;
  color: #fff;
  text-decoration: none;
}
.finish-btn--premium {
  background: #f8cb00;
  color: #1a1430;
}
.finish-btn--premium:hover {
  background: #ffd83d;
  color: #1a1430;
  text-decoration: none;
}
.finish-btn--ghost {
  background: transparent;
  color: #c8c6d6;
  padding: 11px 16px;
  font-weight: 500;
}
.finish-btn--ghost:hover {
  color: #fff;
}
.finish-btn--ghost i {
  font-size: 10px;
}

@media (max-width: 575.98px) {
  .onboarding-final {
    padding: 32px 14px 48px;
  }
  .upsell {
    padding: 24px 18px;
  }
  .finish-hero__title {
    font-size: 26px;
  }
  .upsell__title {
    font-size: 22px;
  }
}
</style>
